// API 설정
const isDev =
  typeof import.meta !== "undefined"
    ? import.meta.env.MODE === "development"
    : process.env.NODE_ENV === "development";

export const API_CONFIG = {
  VOC_BASE_URL: isDev ? "http://www.voc.standardnetworks.co.kr:8020" : "",
};
